<template>
  <el-row
type="flex"
justify="space-between"
align="middle">
    <div>
      <h1 class="card-container__title">{{ title }} <span class="card-container__subtitle">({{ total }})</span></h1>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        v-if="permission.UPDATE"
        type="primary"
        size="medium"
        icon="el-icon-upload"
        :disabled="disabled"
        :plain="plain"
        :loading="uploading"
        @click="$emit('create')"
        >Upload</el-button
      >
      <el-button
        type="primary"
        size="medium"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
        >Làm mới</el-button
      >
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: "CardTitle",
  props: {
    title: String,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
    size: String,
    selectedFileType: Object,
    permission: Object
  },
  data() {
    return {
      uploading: false,
    };
  },
};
</script>

<style lang="scss" scoped></style>
